// extracted by mini-css-extract-plugin
export default {"icon_button":"Button_icon_button__xWDOg","save_button":"Button_save_button__+Hdur"};